<template>
  <div>
    <el-form :inline="true" :model="query" @keyup.enter.native="pageIndex = 1; load()">
      <el-form-item label="单据类型">
        <el-input v-model="query.docType" placeholder="类型编码" size="small" clearable />
      </el-form-item>
      <el-form-item label="单据名称">
        <el-input v-model="query.docName" placeholder="单据名称" size="small" clearable />
      </el-form-item>
      <el-form-item label="生成方式">
        <el-select v-model="query.genMode" placeholder="全部" size="small" clearable style="width: 120px">
          <el-option label="手动" value="manual" />
          <el-option label="自动" value="auto" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('base:docNumberRule:list')" type="primary" size="small" @click="pageIndex = 1; load()">查询</el-button>
      </el-form-item>
      <el-form-item style="float: right;">
        <el-button v-if="isAuth('base:docNumberRule:save')" type="primary" size="small" @click="open()">新增</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="list" border v-loading="loading" style="width: 100%;" :header-cell-style="headStyle">
      <el-table-column type="index" label="序号" width="60" align="center" />
      <el-table-column prop="docType" label="单据类型" width="150">
        <template slot-scope="scope">
          <span v-if="isAuth('base:docNumberRule:info')" class="code-link" @click="open(scope.row.ruleId, true)">{{ scope.row.docType }}</span>
          <span v-else>{{ scope.row.docType }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="docName" label="单据名称" width="140" />
      <el-table-column prop="genMode" label="生成方式" width="90" align="center">
        <template slot-scope="scope">{{ scope.row.genMode === 'auto' ? '自动' : '手动' }}</template>
      </el-table-column>
      <el-table-column prop="prefix" label="前缀" width="80" />
      <el-table-column prop="datePart" label="日期段" width="100" align="center">
        <template slot-scope="scope">{{ datePartLabel(scope.row.datePart) }}</template>
      </el-table-column>
      <el-table-column prop="serialLength" label="流水位数" width="90" align="center" />
      <el-table-column prop="resetCycle" label="流水重置" width="100" align="center">
        <template slot-scope="scope">{{ resetCycleLabel(scope.row.resetCycle) }}</template>
      </el-table-column>
      <el-table-column prop="enabled" label="启用" width="70" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.enabled === '1' ? 'success' : 'info'" size="mini">{{ scope.row.enabled === '1' ? '是' : '否' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="规则示例" min-width="160" show-overflow-tooltip>
        <template slot-scope="scope">{{ buildExample(scope.row) }}</template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="sizeChange" @current-change="pageChange"
      :current-page="pageIndex" :page-sizes="[20, 50, 100]" :page-size="pageSize" :total="total"
      layout="total, sizes, prev, pager, next, jumper" />
    <doc-number-rule-add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="load" />
  </div>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'
import DocNumberRuleAddOrUpdate from './docNumberRule-add-or-update'

export default {
  name: 'DocNumber',
  components: { DocNumberRuleAddOrUpdate },
  data() {
    return {
      query: { docType: '', docName: '', genMode: '' },
      list: [], pageIndex: 1, pageSize: 20, total: 0, loading: false,
      addOrUpdateVisible: false, permCodes: [],
      headStyle: { background: '#f5f7fa', color: '#606266' }
    }
  },
  created() {
    fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {})
    this.load()
  },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    load() {
      this.loading = true
      request.post('/base/docNumberRule/list', {
        currentPage: this.pageIndex, pageSize: this.pageSize,
        docType: this.query.docType, docName: this.query.docName, genMode: this.query.genMode
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    sizeChange(val) { this.pageSize = val; this.pageIndex = 1; this.load() },
    pageChange(val) { this.pageIndex = val; this.load() },
    open(id, readonly) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => { this.$refs.addOrUpdate.init(id, readonly) })
    },
    datePartLabel(v) {
      const map = { none: '无', yyyy: '年', yyyyMM: '年月', yyyyMMdd: '年月日' }
      return map[v] || v
    },
    resetCycleLabel(v) {
      const map = { never: '不重置', year: '按年', month: '按月', day: '按日' }
      return map[v] || v
    },
    buildExample(row) {
      if (row.genMode !== 'auto') return '手动输入'
      const prefix = row.prefix || ''
      const now = new Date()
      const year = String(now.getFullYear())
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      const dateMap = { none: '', yyyy: year, yyyyMM: year + month, yyyyMMdd: year + month + day }
      const len = row.serialLength || 4
      return prefix + (dateMap[row.datePart] || '') + String(1).padStart(len, '0')
    }
  }
}
</script>

<style scoped>
.code-link { color: #348adb; cursor: pointer; }
.code-link:hover { text-decoration: underline; }
</style>
